// extracted by mini-css-extract-plugin
export default {"topbtn":"scroll_topbtn__24Eql","icon":"scroll_icon__dPmHL","gototop":"scroll_gototop__Fawq4"};